var _line, _line2, _line3, _line4, _line5, _line6, _line7, _path, _line8, _path2, _line9, _line10, _line11, _line12, _path3, _line13, _line14, _line15, _line16, _line17, _path4, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFefco701Template = function SvgFefco701Template(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "625.0mm",
    height: "350.0mm",
    viewBox: "0.0 0.0 625.0 350.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 31,
    y1: 243.00000000000003,
    y2: 346,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 104.6,
    y1: 346,
    y2: 346,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 104.6,
    x2: 108.6,
    y1: 346,
    y2: 350,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 108.6,
    x2: 147.4,
    y1: 350,
    y2: 350,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 147.4,
    x2: 151.4,
    y1: 350,
    y2: 346,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 151.4,
    x2: 195.9,
    y1: 346,
    y2: 346,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 234,
    x2: 280,
    y1: 298,
    y2: 298,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 280 298 L 325 243 L 331 249 L 331 298"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 331,
    x2: 505.59999999999997,
    y1: 298,
    y2: 298,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 505.6 298 L 516 249 L 525 243 L 539.1421 257.1421 C 534 263 534 263 534 283 L 534 295"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 534,
    x2: 557.6,
    y1: 295,
    y2: 295,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 557.6,
    x2: 560.6,
    y1: 295,
    y2: 298,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 560.6,
    x2: 580,
    y1: 298,
    y2: 298,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 580,
    x2: 625,
    y1: 298,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 219 246 L 225 243 L 239.1421 257.1421 C 234 263 234 263 234 283 L 234 298"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 625,
    x2: 525,
    y1: 243.00000000000003,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 451.3999999999999,
    x2: 525,
    y1: 243.00000000000003,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 396.59999999999997,
    x2: 325,
    y1: 243.00000000000003,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 325,
    x2: 225,
    y1: 243.00000000000003,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 225,
    y1: 243.00000000000003,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 398.6 245 l 50.8 0 a 2 2 0 0 0 0 -4 l -50.8 0 a 2 2 0 0 0 0 4"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 239.14213562373095,
    x2: 280,
    y1: 257.14213562373095,
    y2: 298,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 539.142135623731,
    x2: 580,
    y1: 257.14213562373095,
    y2: 298,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 195.9,
    x2: 219,
    y1: 346,
    y2: 246.00000000000003,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 25,
    y1: 243.00000000000003,
    y2: 241.50000000000003,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    x2: 22.7,
    y1: 241.50000000000003,
    y2: 237.9,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 22.7,
    x2: 0,
    y1: 237.9,
    y2: 216.50000000000003,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 66,
    y2: 216.50000000000003,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    x2: 0,
    y1: 53.5,
    y2: 66,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 31,
    y1: 47.5,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 219,
    x2: 31,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 219,
    x2: 219,
    y1: 0,
    y2: 44.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 231,
    x2: 231,
    y1: 44.5,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 319,
    x2: 231,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 319,
    x2: 319,
    y1: 44.5,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 331,
    x2: 331,
    y1: 0,
    y2: 44.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 331,
    x2: 519,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 519,
    x2: 519,
    y1: 44.5,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 531,
    x2: 531,
    y1: 0,
    y2: 44.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 619.75,
    x2: 531,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 619.75,
    x2: 619.75,
    y1: 42.25,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 619.75 42.25 C 619.75 43.25 624 47.5 625 47.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 519 44.5 C 519 45.5 524 47.5 525 47.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 531 44.5 C 531 45.5 526 47.5 525 47.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 319 44.5 C 319 45.5 324 47.5 325 47.5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 331 44.5 C 331 45.5 326 47.5 325 47.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 219 44.5 C 219 45.5 224 47.5 225 47.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 31 47.5 C 31 48.5 26 53.5 25 53.5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 231 44.5 C 231 45.5 226 47.5 225 47.5"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 625,
    x2: 625,
    y1: 47.5,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 25,
    x2: 25,
    y1: 53.5,
    y2: 241.50000000000003,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    x2: 219,
    y1: 44,
    y2: 44,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 225,
    x2: 325,
    y1: 47.5,
    y2: 47.5,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 331,
    x2: 519,
    y1: 44.5,
    y2: 44.5,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 525,
    x2: 625,
    y1: 47.5,
    y2: 47.5,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 525,
    x2: 525,
    y1: 47.5,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 325,
    x2: 325,
    y1: 47.5,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 225,
    x2: 225,
    y1: 47.5,
    y2: 243.00000000000003,
    fill: "none",
    stroke: "#ff0000",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFefco701Template, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fefco-701-template.592e4604.svg";
export { ForwardRef as ReactComponent };